
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsFastWifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 33,
  viewBox: "0 0 29 33"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icons-fast-wifi_29bbda8c1b3a5118__a",
  x1: "62.475%",
  x2: "41.827%",
  y1: "91.249%",
  y2: "3.429%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icons-fast-wifi_29bbda8c1b3a5118__b",
  x1: "76.393%",
  x2: "32.709%",
  y1: "55.819%",
  y2: "43.43%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icons-fast-wifi_29bbda8c1b3a5118__c",
  x1: "76.393%",
  x2: "32.709%",
  y1: "54.222%",
  y2: "45.233%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "var(--theme-primary, #810ea9)"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 0.8,
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#icons-fast-wifi_29bbda8c1b3a5118__a)",
  d: "M19.44 18.416h-3.406l.307-1.028a3.176 3.176 0 1 0-6.11-1.73l-1.517 5.695a.513.513 0 0 0 .494.644h3.383l-2.334 7a.51.51 0 0 0 .875.493l8.697-10.231a.511.511 0 0 0-.39-.843zm-7.377 8.4 1.723-5.167a.51.51 0 0 0-.486-.675H9.873l1.348-5.052a2.152 2.152 0 1 1 4.141 1.173l-.506 1.688a.51.51 0 0 0 .491.656h2.986l-6.27 7.377z",
  transform: "translate(1.207 1.103)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#icons-fast-wifi_29bbda8c1b3a5118__b)",
  d: "M4.619 9.734c-.2.2-.2.524 0 .724l2.17 2.17c.2.2.524.2.724 0a8.186 8.186 0 0 1 11.575.001c.2.2.524.2.724 0l2.17-2.171c.2-.2.2-.524 0-.724-4.798-4.786-12.565-4.786-17.363 0zm14.82 1.819a9.208 9.208 0 0 0-12.277 0l-1.448-1.449a11.271 11.271 0 0 1 15.175 0l-1.45 1.449z",
  transform: "translate(1.207 1.103)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#icons-fast-wifi_29bbda8c1b3a5118__c)",
  d: "M26.323 5.394c-7.197-7.18-18.848-7.18-26.045 0-.2.2-.2.523 0 .723l2.17 2.17c.2.2.524.2.724 0 5.598-5.585 14.66-5.585 20.258 0 .2.2.523.2.723 0l2.17-2.17c.2-.2.2-.524 0-.723zm-2.539 1.815c-5.903-5.51-15.064-5.51-20.967 0L1.369 5.76c6.704-6.307 17.159-6.307 23.863 0l-1.448 1.45z",
  transform: "translate(1.207 1.103)"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"29\" height=\"33\" viewBox=\"0 0 29 33\">\r\n    <defs>\r\n        <linearGradient id=\"y570eghyea\" x1=\"62.475%\" x2=\"41.827%\" y1=\"91.249%\" y2=\"3.429%\">\r\n            <stop offset=\"0%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n            <stop offset=\"100%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n        </linearGradient>\r\n        <linearGradient id=\"tf9gcsvneb\" x1=\"76.393%\" x2=\"32.709%\" y1=\"55.819%\" y2=\"43.43%\">\r\n            <stop offset=\"0%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n            <stop offset=\"100%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n        </linearGradient>\r\n        <linearGradient id=\"5bs4c4av5c\" x1=\"76.393%\" x2=\"32.709%\" y1=\"54.222%\" y2=\"45.233%\">\r\n            <stop offset=\"0%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n            <stop offset=\"100%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n        </linearGradient>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill-rule=\"nonzero\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\".8\">\r\n            <g>\r\n                <path fill=\"url(#y570eghyea)\" d=\"M19.44 18.416h-3.406l.307-1.028c.288-.96.105-2.002-.494-2.807-.599-.805-1.543-1.28-2.547-1.28-1.438 0-2.697.967-3.069 2.357l-1.517 5.695c-.041.154-.008.318.088.444.097.126.247.2.406.2h3.383l-2.334 7c-.077.233.021.487.235.607.213.12.482.072.64-.114l8.697-10.231c.129-.152.158-.365.074-.546-.083-.181-.265-.297-.464-.297zm-7.377 8.4l1.723-5.167c.053-.156.027-.328-.07-.462-.096-.134-.25-.213-.416-.213H9.873l1.348-5.052c.251-.942 1.104-1.598 2.08-1.598.68 0 1.32.321 1.726.867.406.546.53 1.252.335 1.904l-.506 1.688c-.046.155-.016.322.081.45.097.13.248.206.41.206h2.986l-6.27 7.377z\" transform=\"translate(-1) translate(2.207 1.103)\"/>\r\n                <path fill=\"url(#tf9gcsvneb)\" d=\"M4.619 9.734c-.2.2-.2.524 0 .724l2.17 2.17c.2.2.524.2.724 0 1.535-1.534 3.617-2.397 5.787-2.397 2.171 0 4.253.863 5.788 2.398.2.2.524.2.724 0l2.17-2.171c.2-.2.2-.524 0-.724-4.798-4.786-12.565-4.786-17.363 0zm14.82 1.819c-3.495-3.126-8.782-3.126-12.277 0l-1.448-1.449c4.3-3.915 10.874-3.915 15.175 0l-1.45 1.449z\" transform=\"translate(-1) translate(2.207 1.103)\"/>\r\n                <path fill=\"url(#5bs4c4av5c)\" d=\"M26.323 5.394c-7.197-7.18-18.848-7.18-26.045 0-.2.2-.2.523 0 .723l2.17 2.17c.2.2.524.2.724 0 5.598-5.585 14.66-5.585 20.258 0 .2.2.523.2.723 0l2.17-2.17c.2-.2.2-.524 0-.723zm-2.539 1.815c-5.903-5.51-15.064-5.51-20.967 0L1.369 5.76c6.704-6.307 17.159-6.307 23.863 0L23.784 7.21z\" transform=\"translate(-1) translate(2.207 1.103)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-fast-wifi.29bbda8c1b3a511815c08a921fa91aef.svg"),
        {
          React: SvgIconsFastWifi,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      